/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

const appRoutes = {
  login: "/login",
  forgotPassword: "/forgot-password",
  recover: "/recover",
  changePassword: "/changePassword",
  signUp: "/signup",
  signUpSuccess: "/signup/success",
  dashboard: "/patientsQueue",
  //dashboard: "/dashboard",
  testConnection: "/testConnection",
  notifications: "/notifications",
  consultHistory: "/consult/history",
  consultHistoryView: "/consult/View",
  tickets: "/tickets",
  editTicket: "/ticket/edit",
  openAppointments: "/open/appointments",
  viewAppointment: "/view/appointment",
  myAppointments: "/my/appointments",
  profile: "/profile",
  editProfile: "/edit/profile",
  bankDetails: "/account/details",
  editBankDetails: "/edit/account/details",
  addBankDetails: "/add/account",
  consultCost: "/consultCost",
  paymentSummary: "/paymentSummaries",
  taxInvoice: "/taxInvoice",
  help: "/help",
  legal: "/legal",
  callRequestReceive: "/patient/call/request",
  callRequestAccepted: "/patient/call/accepted",
  patientsQueue: "/patientsQueue",
  viewForum: "/forum",
  createForumPost: "/createForumPost",
  forumPostDetails: "/forumPostDetails",
  instantExtraDoctorSchedule: "/app/instant-extras/doctorSchedule",
  instantSwitch: "/instant-switch/assessments",
  instantLeaf: "/instant-leaf/assessments",
  instantSwitchAcceptAssessment: "/instant-switch/accept-assessment",
  instantSwitchViewCompletedAssessment: "/instant-switch/view/assessment",
  instantHush: "/instant-hush/assessments",
  instantHushAcceptAssessment: "/instant-hush/accept/assessment",
  instantHushViewCompletedAssessment: "/instant-hush/view/assessment",
  tagTopicsCPD: "/tag-topics-cpd-mo"
};

export default appRoutes;
